import {
	type CreateNewsItem,
	type NewsStatus,
	newsItemSchema,
	type UpdateNewsItem,
} from "../schemas/news";
import { fetchApi, fetchVoid, paginatedSchema } from "./internal";

export type NewsSortField = "created_at" | "published_at" | "title" | "status";
export type NewsSortOrder = "asc" | "desc";

export type NewsListParams = {
	limit?: number;
	offset?: number;
	status?: NewsStatus;
	q?: string;
	sort_by?: NewsSortField;
	order?: NewsSortOrder;
};

export const news = {
	create: (data: CreateNewsItem) =>
		fetchApi("/admin/news", newsItemSchema, {
			body: JSON.stringify(data),
			method: "POST",
		}),
	delete: (id: string) => fetchVoid(`/admin/news/${id}`, { method: "DELETE" }),
	get: (id: string) => fetchApi(`/admin/news/${id}`, newsItemSchema),
	list: (params?: NewsListParams) => {
		const search = new URLSearchParams();
		if (params?.limit !== undefined) search.set("limit", String(params.limit));
		if (params?.offset !== undefined) search.set("offset", String(params.offset));
		if (params?.status !== undefined) search.set("status", params.status);
		if (params?.q !== undefined) search.set("q", params.q);
		if (params?.sort_by !== undefined) search.set("sort_by", params.sort_by);
		if (params?.order !== undefined) search.set("order", params.order);
		const qs = search.toString();
		return fetchApi(`/admin/news${qs ? `?${qs}` : ""}`, paginatedSchema(newsItemSchema));
	},
	publish: (id: string) =>
		fetchApi(`/admin/news/${id}/publish`, newsItemSchema, { method: "POST" }),
	unpublish: (id: string) =>
		fetchApi(`/admin/news/${id}/unpublish`, newsItemSchema, {
			method: "POST",
		}),
	update: (id: string, data: UpdateNewsItem) =>
		fetchApi(`/admin/news/${id}`, newsItemSchema, {
			body: JSON.stringify(data),
			method: "PUT",
		}),
};
